<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
          <divisoria-descricao
            :titulo="!filial && tipoProposta === 'constituicao' ? 'Sócios' : 'Contratante'"
            :descricao="getTextoGrupoContratante"
          >
            <template slot="complemento-numero">
              <div class="circle">
                1
              </div>
            </template>
          </divisoria-descricao>
        </b-col>
      </b-row>
      <b-row
        v-if="!filial && tipoProposta === 'constituicao'"
        class="mb-50"
      >
        <b-col>
          <div
            v-for="(socio, $index) in valueInner.socios"
            :key="$index"
            class="socio-asterisco-scope"
          >
            <socio-empresa
              :ref="`socio${socio.code}`"
              :socio="socio"
              :desabilitar-nome="valueInner.enviadoParaAnalise === true"
              :externo="true"
              :disabled="valueInner.enviadoParaAnalise"
              :enviado-analise="valueInner.enviadoParaAnalise"
              :desabilita-anexo="valueInner.enviadoParaAnalise"
              :lista-emails="valueInner.socios"
              @adicionar-item="adicionarItem($event)"
              @remover-item="removerItem($index)"
              @adicionar-contratante="adicionarContratante($event)"
              @verificar-responsavel="verificarRFB($event)"
            />
          </div>
        </b-col>
      </b-row>

      <b-row
        v-if="filial && tipoProposta === 'constituicao'"
        class="mb-50"
      >
        <b-col cols="12">
          <b-form-group>
            <b-row style="display: flex;align-items: center;">
              <b-col cols="auto">
                <validation-provider
                  #default="{ errors }"
                  :rules="'required'"
                >
                  <b-form-group label="CPF sócio">
                    <inscricao-federal
                      v-model="valueInner.cpfResponsavelRFB"
                      :disabled="valueInner.enviadoParaAnalise"
                    />
                  </b-form-group>
                  <small
                    v-if="errors[0]"
                    class="text-danger"
                  >Campo obrigatório</small>
                </validation-provider>
              </b-col>
              <div>
                <i>
                  <font-awesome-icon
                    :icon="faQuestionCircle"
                  />
                  Informe primeiramente o CPF do sócio que é responsável perante a RFB
                </i>
              </div>
            </b-row>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row
        v-if="filial && tipoProposta === 'constituicao'"
        class="mb-50"
      >
        <b-col>
          <b-row>
            <b-col cols="4">
              <b-form-group label="CNPJ Matriz">
                <validation-provider
                  #default="{ errors }"
                  :rules="'required'"
                >
                  <b-input-group>
                    <inscricao-federal
                      v-model="valueInner.inscricaoCNPJMatriz"
                      :tipo-inscricao="'cnpj'"
                      :disabled="valueInner.enviadoParaAnalise || valueInner.cpfResponsavelRFB === undefined || valueInner.cpfResponsavelRFB === ''"
                    />
                    <b-input-group-append>
                      <b-button
                        v-b-tooltip.hover
                        title="Busca dados da RFB"
                        :variant="valueInner.erroNavegacaoMatriz ? 'danger' : 'primary'"
                        style="float:right"
                        :disabled="valueInner.enviadoParaAnalise|| valueInner.cpfResponsavelRFB === undefined || valueInner.cpfResponsavelRFB === ''"
                        @click="buscarSocios(valueInner.inscricaoCNPJMatriz)"
                      >
                        <feather-icon
                          v-if="!buscaSocios"
                          icon="SearchIcon"
                        />
                        <feather-icon
                          v-if="!valueInner.erroNavegacaoMatriz && buscaSocios"
                          icon="CheckIcon"
                        />
                        <feather-icon
                          v-if="valueInner.erroNavegacaoMatriz && buscaSocios"
                          icon="RotateCwIcon"
                        />
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                  <small
                    v-if="errors[0]"
                    class="text-danger"
                  >Campo obrigatório</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group label="Razão Social">
                <b-form-input
                  v-model="valueInner.nomeEmpresarialCNPJ"
                  :disabled="true"
                />
              </b-form-group>
            </b-col>
            <b-col cols="2">
              <b-form-group label="Tipo">
                <b-form-input
                  v-model="valueInner.matrizFilialCNPJ"
                  :disabled="true"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <small
            v-if="valueInner.erroNavegacaoMatriz && !isLoading"
            class="text-danger"
          >Não foi possível concluir a busca de dados na RFB, verifique o CNPJ informado e tente novamente!</small>
          <small v-else-if="tipoProposta === 'constituicao' && filial && valueInner.matrizFilialCNPJ === 'Filial'">Atenção: em propostas de Constituição de filial deve ser informado o CNPJ de Matriz para a busca de dados na RFB!</small>
          <small v-else-if="tipoProposta === 'constituicao' && filial && !encontradoSocios">Não foi encontrado sócios vinculados a essa empresa na RFB! Cadastre os sócios manualmente nos campos abaixo.</small>
        </b-col>
      </b-row>

      <b-row class="mt-1">
        <b-col>
          <divisoria-descricao
            :titulo="!filial && tipoProposta === 'constituicao' ? 'Contratante' : 'Sócios'"
            :descricao="getTextoGrupoSocio"
          >
            <template slot="complemento-numero">
              <div class="circle">
                2
              </div>
            </template>
          </divisoria-descricao>
        </b-col>
      </b-row>

      <b-row v-if="!filial && tipoProposta === 'constituicao'">
        <b-col cols="3">
          <b-form-group label="CPF">
            <inscricao-federal
              :value="valueInner.cpfResponsavelRFB"
              :disabled="true"
            />
          </b-form-group>
        </b-col>
        <b-col cols="9">
          <b-form-group label="Sócio">
            <b-input
              v-model="valueInner.nomeContratante"
              :disabled="true"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row v-if="filial && tipoProposta === 'constituicao'">
        <b-col>
          <div
            v-for="(socio, $index) in valueInner.socios"
            :key="$index"
            class="socio-asterisco-scope"
          >
            <socio-empresa
              :ref="`socio${socio.code}`"
              :socio="socio"
              :desabilitar-nome="(filial && !valueInner.primeiraBuscaMatriz) || (valueInner.enviadoParaAnalise) || (socio.veioDoHub) || (socio.veioDoRFB)"
              :externo="true"
              :disabled="(filial && !valueInner.primeiraBuscaMatriz) || (socio.veioDoHub) || (valueInner.enviadoParaAnalise)"
              :enviado-analise="valueInner.enviadoParaAnalise"
              :desabilita-anexo="valueInner.enviadoParaAnalise"
              :lista-emails="valueInner.socios"
              @adicionar-item="adicionarItem($event)"
              @remover-item="removerItem($index)"
              @verificar-responsavel="verificarRFB($event)"
            />
          </div>
        </b-col>
      </b-row>

      <certificado-e-anexo
        ref="anexos"
        v-model="valueInner.anexosECertificado"
        :pre-geracao-id="valueInner.id"
        :tipo-proposta="tipoProposta"
        :filial="filial"
        :desabilitar-campos="valueInner.enviadoParaAnalise"
      />

      <b-row class="mt-1">
        <b-col>
          <divisoria-descricao
            :titulo="'Outras informações'"
            :descricao="'Informe o e-mail para recebimento dos boletos e NFs'"
          >
            <template slot="complemento-numero">
              <div class="circle">
                5
              </div>
            </template>
          </divisoria-descricao>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="4">
          <loading
            :is-loading="isLoading"
            :cancelar-upload="cancelarBusca"
            :show-message="'Prezado, estamos buscando os dados. Aguarde!'"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <email-input
            :value="valueInner.emailsBoletosNFs"
            :require="true"
            :disabled="valueInner.enviadoParaAnalise"
            @input="adicionarEmail($event)"
          />
        </b-col>
      </b-row>
      <b-row class="mt-1">
        <b-form-group
          label="Descrição (opcional)"
          class="col-12"
        >
          <b-textarea
            v-model="valueInner.descricao"
            :disabled="valueInner.enviadoParaAnalise"
          />
        </b-form-group>
      </b-row>
    </b-col>
  </b-row>
</template>

<style lang="scss">
.circle {
  width: 25px;
  height: 25px;
  line-height: 25px;
  border: 1px solid #5e5873;
  border-radius: 50%;
  text-align: center;
  color: #5e5873;
  display: inline-block;
}

</style>

<script>
import axios from 'axios'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faQuestionCircle,
} from '@fortawesome/free-solid-svg-icons'
import { generateCode } from '@core/utils/utils'
import { ValidationProvider } from 'vee-validate'
import api from '@/app-modulo/comercial/portal-proposta/shared/services/api'
import { getUserInfo } from '@/auth/utils'

export default {
  name: 'ConstituicaoMatriz',
  components: {
    FontAwesomeIcon,
    ValidationProvider,
    DivisoriaDescricao: () => import('@/shared/components/divisoria-descricao/DivisoriaDescricao.vue'),
    SocioEmpresa: () => import('@/shared/components/socio-empresa-contrato/SocioEmpresaContrato.vue'),
    CertificadoEAnexo: () => import('../certificado-e-anexos/CertificadoEAnexos.vue'),
    Loading: () => import('@/shared/components/loading/Loading.vue'),
    InscricaoFederal: () => import('@/shared/components/inscricao-federal/InscricaoFederal.vue'),
    EmailInput: () => import('@/@pilar/components/email-input/EmailInput.vue'),
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    filial: {
      type: Boolean,
      default: false,
    },
    tipoProposta: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      buscaSocios: false,
      faQuestionCircle,
      isLoading: false,
      asteriscoTimer: null,
      valueInner: {
        emailsBoletosNFs: [],
        enviadoParaAnalise: false,
        empresas: [],
        socios: [{
          inscricao: null,
          tipoInscricao: 'cpf',
          veioDoRFB: false,
          telefoneContato: {
            telefone: null,
            telefoneWhatsApp: false,
            celular: null,
            celularWhatsApp: false,
          },
          code: generateCode(),
        }],
        anexosECertificado: {
          certificadoSelecionado: false,
          contratualSelecionado: false,
          outrosSelecionado: false,
          certificado: [],
          senhaCertificado: null,
          tipoCertificado: null,
          dataVencimentoCertificado: null,
          certificadoFisico: null,
          nomeArquivoContratual: null,
          nomeArquivoOutrosAnexos: null,
          nomeArquivoCertificado: null,
          semCertificado: false,
        },
        cpfResponsavelRFB: null,
        nomeContratante: null,
        inscricaoCNPJMatriz: null,
        erroNavegacaoMatriz: false,
        primeiraBuscaMatriz: false,
        matrizFilialCNPJ: null,
        nomeEmpresarialCNPJ: null,
      },
      encontradoSocios: true,
      invalidTags: [],
      duplicateTags: [],
    }
  },
  computed: {
    getTextoGrupoContratante() {
      if (!this.filial && this.tipoProposta === 'constituicao') {
        return 'Aqui você pode adicionar os sócios com suas informações detalhadas'
      }
      return 'Nos contratos de constituição de Filial, informe o CNPJ da Matriz nos dados do contratante'
    },
    getTextoGrupoSocio() {
      if (!this.filial && this.tipoProposta === 'constituicao') {
        return 'Nos contratos de constituição de Matriz, contratante é vinculado de forma automática ao marcar o sócio como responsável perante a RFB'
      }
      return 'Aqui você pode adicionar os sócios com suas informações detalhadas'
    },
  },
  watch: {
    value(value, oldValue) {
      if (value !== oldValue) {
        this.valueInner = value
        if (!this.valueInner.id || this.valueInner.id === 0) {
          this.valueInner.emailsBoletosNFs.push(getUserInfo().email)
        }
        this.adicionarContratanteExistente()
        this.scheduleAplicarAsteriscosSocio()
      }
    },
  },
  created() {
    this.valueInner = this.value
    if (!this.valueInner.id || this.valueInner.id === 0) {
      this.valueInner.emailsBoletosNFs.push(getUserInfo().email)
    }
    this.adicionarContratanteExistente()
  },
  mounted() {
    this.scheduleAplicarAsteriscosSocio()
  },
  updated() {
    this.scheduleAplicarAsteriscosSocio()
  },
  beforeDestroy() {
    if (this.asteriscoTimer) {
      clearTimeout(this.asteriscoTimer)
      this.asteriscoTimer = null
    }
  },
  methods: {
    scheduleAplicarAsteriscosSocio() {
      if (this.asteriscoTimer) {
        clearTimeout(this.asteriscoTimer)
      }
      this.asteriscoTimer = setTimeout(() => {
        this.$nextTick(() => {
          this.aplicarAsteriscosSocio()
        })
      }, 0)
    },
    aplicarAsteriscosSocio() {
      const targets = [
        'Data de nascimento',
        'Profissão',
        'Função',
        'Nacionalidade',
        'Estado Civil',
        'E-mail',
      ]

      const scopes = this.$el ? this.$el.querySelectorAll('.socio-asterisco-scope') : []
      scopes.forEach(scopeEl => {
        const nodes = scopeEl.querySelectorAll('label, legend')
        nodes.forEach(node => {
          if (!node || node.querySelector('[data-required-asterisk="1"]')) return

          const raw = (node.textContent || '').replace(/\s+/g, ' ').trim()
          const match = targets.some(t => raw === t || raw.startsWith(`${t} `) || raw.startsWith(t))

          if (!match) return

          const span = document.createElement('span')
          span.setAttribute('data-required-asterisk', '1')
          span.className = 'text-danger'
          span.textContent = ' *'
          node.appendChild(span)
        })
      })
    },
    adicionarEmail(value) {
      this.valueInner.emailsBoletosNFs = value
    },
    adicionarContratanteExistente() {
      if (this.valueInner.socios && this.valueInner.socios.length > 0) {
        const socio = this.valueInner.socios.find(find => find.responsavelRFB)
        if (socio) {
          this.$set(this.valueInner, 'cpfResponsavelRFB', socio.inscricao)
          this.$set(this.valueInner, 'nomeContratante', socio.nome)
        }
      }
    },
    adicionarContratante(value) {
      if (value.responsavel && !this.filial && this.tipoProposta === 'constituicao') {
        this.$set(this.valueInner, 'cpfResponsavelRFB', value.contratante.inscricao)
        this.$set(this.valueInner, 'nomeContratante', value.contratante.nome)
      } else if (!value.responsavel && !this.filial && this.tipoProposta === 'constituicao') {
        this.valueInner.cpfResponsavelRFB = null
        this.valueInner.nomeContratante = null
      }
    },
    adicionarItem() {
      if (!this.valueInner.enviadoParaAnalise) {
        const item = {
          veioDoRFB: false,
          veioDoHub: false,
          inscricao: null,
          tipoInscricao: 'cpf',
          responsavelRFB: false,
          socioAdministrador: false,
          telefoneContato: {
            telefone: null,
            telefoneWhatsApp: false,
            celular: null,
            celularWhatsApp: false,
          },
          code: generateCode(),
        }
        this.valueInner.socios.push(item)
      }
    },
    removerItem(index) {
      if (!this.valueInner.enviadoParaAnalise) {
        this.valueInner.socios.splice(index, 1)

        if (this.valueInner.socios.length === 0) {
          this.adicionarItem()
        }

        const socio = this.valueInner.socios.some(find => find.responsavelRFB)
        if (!socio) {
          this.$set(this.valueInner, 'cpfResponsavelRFB', null)
          this.$set(this.valueInner, 'nomeContratante', null)
        }
      }
    },
    buscarSocios(inscricao) {
      this.buscaSocios = true
      this.isLoading = true
      if (inscricao && inscricao !== '' && this.valueInner.cpfResponsavelRFB !== '') {
        api.getSociosMatriz({ cadastroFederal: inscricao, constituicao: true, cadastroPessoa: this.valueInner.cpfResponsavelRFB }, axios.CancelToken)
          .then(payload => {
            const dados = payload.data
            this.$set(this.valueInner, 'nomeEmpresarialCNPJ', dados.nomeEmpresarialCNPJ)
            this.$set(this.valueInner, 'matrizFilialCNPJ', dados.matrizFilialCNPJ)
            this.$set(this.valueInner, 'erroNavegacaoMatriz', dados.erroNavegacaoMatriz)

            this.valueInner.primeiraBuscaMatriz = true
            this.isLoading = false
            if (dados.empresas && dados.empresas.some(som => som.inscricao)) {
              const item = this.valueInner.empresas[0]
              if (item) {
                dados.empresas[0].empresaId = item.empresaId
              }
              this.valueInner.empresas = dados.empresas
            }

            if (this.valueInner.socios.length > 0 && this.valueInner.socios.some(som => som.nome && som.nome !== '')) {
              this.valueInner.socios = this.valueInner.socios.filter(filter => !filter.veioDoRFB && !filter.veioDoHub)
              dados.socios.forEach(socio => {
                this.valueInner.socios.push(socio)
              })
            } else {
              this.encontradoSocios = (dados.socios && dados.socios.length > 0)

              if (this.encontradoSocios) {
                this.valueInner.socios = dados.socios
              }
            }
          }).catch(err => {
            this.isLoading = false
            throw err
          })
      }
    },
    verificarRFB(value) {
      const responsavel = this.valueInner.socios.find(find => find !== value.socio && find.responsavelRFB)
      if (responsavel) {
        responsavel.responsavelRFB = false
      }
    },
    mostrarErro(erro) {
      if (erro !== undefined && erro.includes('field is required')) {
        return erro.replace('The', '').replace('field is required', 'é um campo obrigatório')
      }
      return erro
    },
    cancelarBusca() {
      this.$emit('closeInCancel')
      this.isLoading = false
      api.cancelarBusca()
    },
    retornaTodosArquivos() {
      const arquivos = []
      for (let index = 0; index < this.valueInner.socios.length; index += 1) {
        const { code } = this.valueInner.socios[index]
        const arquivo = this.$refs[`socio${code}`][0].$refs[`upload${code}`].value[0]
        if (arquivo) {
          arquivos.push({
            file: arquivo.file,
            nome: `${code};${arquivo.filename || arquivo.name}`,
          })
        }
      }
      return arquivos
    },
    onTagState(valid, invalid, duplicate) {
      this.invalidTags = invalid
      this.duplicateTags = duplicate
    },
    validator(tag) {
      const re = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(tag)
    },
    mudarParaLowerCase(value) {
      const emails = []
      value.forEach(each => emails.push(each.toLowerCase()))
      this.valueInner.emailsBoletosNFs = emails
    },
  },
}
</script>
